import { render, staticRenderFns } from "./SuppliersCreateModal.vue?vue&type=template&id=df9ae4cc&"
import script from "./SuppliersCreateModal.vue?vue&type=script&lang=js&"
export * from "./SuppliersCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports